import { SUPPORTED_MODEL_PREDICATE_IRIS } from 'src/templates/queries/iris';

/**
 * Checks if there are predicates that are unsupported by Designer from triples in the model.
 *
 * Used to determine whether parts of the model are unsupported by Designer,
 * and whether to show the user a warning when importing/uploading a model
 *
 * **Call Frequency**
 *
 * Called once when a model is imported or uploaded through file
 *
 * **Context**
 * - Named graphs: set by the user (default is `reasoning.schema.graphs` value,
 *   which by default is `tag:stardog:api:context:local`)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
# All model parts
ASK {
  ?subject ?predicate ?object
  FILTER (?predicate NOT IN 
    <http://www.w3.org/2000/01/rdf-schema#comment>, <http://www.w3.org/2004/02/skos/core#definition>
  ))
}
 * ```
 */
export const unsupportedPredicatesQuery = (
  otherIris: string[]
) => `# Unsupported predicates
ASK {
  ?subject ?predicate ?object .
  FILTER (?predicate NOT IN (
    ${[...SUPPORTED_MODEL_PREDICATE_IRIS, ...otherIris]
      .map((iri) => `<${iri}>`)
      .join(', ')}
  ))
}`;
